import React from "react";
import { useHistory } from "react-router-dom";
import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";

import {
  CardWrapper,
  Wrapper,
  ConfirmDialogStyled,
} from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../companies/list/styles";
import { Filters } from "./filters";
import { FilterType } from "./type";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";
import { UserProps, UserResponseModel } from "../../../../../domain/models/user";

type PageProps = {
  list?: UserResponseModel;
  loading?: boolean;
  handleReload: (filters: FilterType) => void;
  handleDelete: (id: number) => void;
};

const ListPage: React.FC<PageProps> = ({
  list,
  loading,
  handleReload,
  handleDelete,
}) => {
  const history = useHistory();
  const [remove, setRemove] = React.useState<UserProps | undefined>();

  const fields: ItemField[] = [
    {
      title: "Nome",
      key: "name",
      renderItem: (data: UserProps) =>
        data.name || "-",
    },
    {
      title: "email",
      key: "email",
      renderItem: (data: UserProps) =>
        data.email || "-",
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/super-dev/${data?.id}?edit=true`)}
            title="Editar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/super-dev/${data?.id}`)}
            title="Ver"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="eye"
              color={theme.colors.lightBlue}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemove(data);
            }}
            title="Excluir"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="trash"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];

  return (
    <Wrapper>
      <BackButtom text="Listagem de Admin's" />
      <CardWrapper>
        <Filters onChange={handleReload} />
        <Link className="button-create" to="/admin/super-dev/new" invertColor={false}>
          Novo admin <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={0}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        header="Você confirma a exclusão desse SUPER ADMIN?"
        message="Ao excluir, todos os dados relacionados a este SUPER ADMIN serão removidos. As Notas já geradas perderão a associação com este SUPER ADMIN."
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          if (remove?.id) {
            handleDelete(remove.id);
          }
        }}
        reject={() => setRemove(undefined)}
      />
    </Wrapper>
  );
};
export default ListPage;
